<template>
 
  <ReConfirmDelete
    v-model="confirmDialog"
    :project="projectToDelete"
    @deleted="reemitDeleted"
  />
  <v-dialog v-model="dialog" max-width="700" persistent>
    <v-card class="pa-4">
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="text-h6">Eliminar Proyecto</span>

        <v-btn icon variant="text" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <ProjectDeleteInfo :project="project" />

      <v-divider />

      <v-card-actions class="justify-end">
        <v-btn
          variant="tonal"
          color="secondary"
          size="large"
          rounded="x1"
          @click="close"
          >Cancelar</v-btn
        >

        <v-btn
          variant="elevated"
          color="error"
          size="large"
          rounded="x1"
          @click="openConfirmDialog(project)"
        >
          Eliminar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import ProjectDeleteInfo from "@/components/delete/ProjectDeleteInfo.vue";
import ReConfirmDelete from "@/components/delete/ReConfirmDelete.vue"

export default {
  name: "DeleteProyectoGPT",
  components: {
    ProjectDeleteInfo,
    ReConfirmDelete
  },

  props: {
    modelValue: Boolean,
    project: { type: Object, default: null },
    apiBase: { type: String, default: "http://127.0.0.1:8005" },
    apiPrefix: { type: String, default: "/login" },
  },
  emits:["deleted"],
  data() {
    return {
      loadingLocal: false,
      confirmDialog: false,
      snackbar: false,
      snackbarText: "",
      projectToDelete:null
    };
  },

  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
    projectName() {
      return (
        this.project?.nombre ?? this.project?.nameProyect ?? this.projectKey
      );
    },
    projectKey() {
      return this.project?.clave ?? this.project?.idProyect ?? "";
    },
    projectClient() {
      return this.project?.cliente ?? this.project?.UnitBussines ?? "-";
    },

    projectLead() {
      return (
        this.project?.qaLead ??
        this.project?.responsable ??
        this.project?.accountable ??
        "-"
      );
    },
  },

  methods: {
    reemitDeleted(){
      this.$emit('deleted');
       this.$emit("update:modelValue", false);
    },
    showError(msg) {
      this.snackbarText = msg;
      this.snackbar = true;
    },
    openConfirmDialog(project) {
      this.projectToDelete = project
      this.confirmDialog = true;
    },
    close() {
      this.$emit("update:modelValue", false); // asi a mi mismo el objeto
    },
   
  },
};
</script>
